import Route from '@ember/routing/route';
import { get } from '@ember/object';

export default Route.extend({
  setupController(controller) {
    this._super(...arguments);
    controller.reset();
    if (Object.keys(get(controller, 'expandedSections')).length === 0) {
      controller.expandAllSections();
    }
  },

  resetController(controller, isExiting) {
    controller.set('preserveScrollPosition', true);
    if (isExiting) {
      controller.reset();
    }
  },
});
